import type {Button} from '@superweb/ui'
import React, {Suspense, useState} from 'react'

import {useConfig} from '../../../../../../config'
import {Resource} from '../../../../../../utils'
import {useDownloadErrorHandler} from '../../hooks'
import styleClasses from './classes.module.css'
import {DownloadButton} from './DownloadButton'

type Props = {tariff: string; zone: string; country: string} & React.ComponentProps<typeof Button>

export function CargoDownloadButtonContainer({tariff, zone, country, ...buttonProps}: Props) {
  const [excelResource, setExcelResource] = useState<Resource<boolean>>()
  const errorHandler = useDownloadErrorHandler()
  const {tariffsService} = useConfig()

  const onButtonClick = () => {
    setExcelResource(new Resource(() => tariffsService.fetchCargoExcel(country, zone, tariff).catch(errorHandler)))
  }

  return (
    <Suspense
      fallback={
        <div className={styleClasses.cargoDownloadButtonSuspenseWrapper}>
          <DownloadButton {...buttonProps} progress />
        </div>
      }
    >
      <div className={styleClasses.cargoDownloadButtonWrapper}>
        <DownloadButton {...buttonProps} fileResource={excelResource} onPress={onButtonClick} />
      </div>
    </Suspense>
  )
}
